import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPage, hasError } from '../../../states/page/selectors';
import withCalendar from '../../../containers/withCalendar';

import IFTPaymentList from '../IFTPayments/IFTPaymentList';
import {
	iftAddPayments,
	submitIFTPaymentsForReview,
	continueToPaymentDetails,
	submitIFTConfirmedPayments,
} from '../../../states/ift/actions';

import AddPayeeLayoutContainer from '../../../payees/components/LayoutContainer';
import IFTLandingPage from '../IFTLandingPage/IFTLandingPage';
import { goToPage, pages, resetApp } from '../../../states/page/actions';
import { TYPE_IFT } from '../../../config';
import IFTPaymentDetails from '../IFTPaymentDetails/IFTPaymentDetails';
import IFTReviewPage from '../IFTReview/IFTReviewPage';
import IFTConfirmedPage from '../IFTConfirmed/IFTConfirmedPage';
import { withScrollTop } from '../../../containers/withScrollTop';
import IFTPayeePage from '../IFTPayeePage/IFTPayeePage';
import AccountPickerPage from '../../../sharedComponents/AccountPickerPage/AccountPickerPage';
import PaymentTimedOutModal from '../../../sharedComponents/PaymentTimedOutModal';
import { hasGroupApprovalsEnabled } from '../../../states/modes/selectors';

const mapState = (state) => ({
	page: getPage(state),
	hasError: hasError(state),
	hasGroupApprovalsEnabled: hasGroupApprovalsEnabled(state),
});

const mapDispatch = (dispatch) => ({
	submitIFTPaymentsForReview: () => dispatch(submitIFTPaymentsForReview),
	submitIFTConfirmedPayments: () => dispatch(submitIFTConfirmedPayments),
	addPayments: (fromAccount, toAccounts) => dispatch(iftAddPayments({ fromAccount, toAccounts })),
	continueToPayments: () => dispatch(goToPage(pages.IFTPayments)),
	continueToPaymentDetails: () => dispatch(continueToPaymentDetails),
	reset: () => dispatch(resetApp),
});

class LayoutContainer extends Component {
	constructor(props) {
		super(props);

		this.handleContinue = this.handleContinue.bind(this);
		this.handleReset = this.handleReset.bind(this);
		this.handlePayeesSelected = this.handlePayeesSelected.bind(this);
	}
	componentDidUpdate() {
		const { hasError, handleRoute } = this.props;

		if (hasError) {
			handleRoute('WEB-ERROR');
		}
	}
	handleContinue() {
		const { page, submitIFTPaymentsForReview, submitIFTConfirmedPayments } = this.props;
		switch (page) {
			case pages.IFTPaymentDetails:
			case pages.IFTPayments:
				submitIFTPaymentsForReview();
				break;
			case pages.IFTReview:
				submitIFTConfirmedPayments();
				break;
			default:
				break;
		}
	}

	handleReset() {
		const { resetPaymentList, reset } = this.props;
		resetPaymentList();
		reset();
	}

	handlePayeesSelected(selectedToPayees, fromAccount) {
		const { addPayments, continueToPayments, continueToPaymentDetails } = this.props;

		addPayments(fromAccount, selectedToPayees);
		if (selectedToPayees.length === 1) return continueToPaymentDetails();
		return continueToPayments();
	}

	render() {
		const {
			page,
			handleSelectPaymentType,
			handleRoute,
			handlePaymentInReview,
			hasGroupApprovalsEnabled,
			isBootStrapInProgress,
			handleBackParent,
			handleDisplayFullwidth,
		} = this.props;

		switch (page) {
			case pages.IFTLandingPage:
				return (
					<div>
						<IFTLandingPage
							handleDisplayFullwidth={handleDisplayFullwidth}
							onPayeeListContinue={this.handlePayeesSelected}
							showTemplateSelector={false}
							paymentType={TYPE_IFT}
							handleSelectPaymentType={handleSelectPaymentType}
							isBootStrapInProgress={isBootStrapInProgress}
						/>
					</div>
				);
			case pages.IFTPayments:
				return (
					<div>
						<IFTPaymentList handleContinue={this.handleContinue} handleDisplayFullwidth={handleDisplayFullwidth} />
					</div>
				);
			case pages.IFTPayeeSelector:
				return <IFTPayeePage handleDisplayFullwidth={handleDisplayFullwidth} />;
			case pages.IFTAccountPicker:
				return <AccountPickerPage pageId={pages.IFTLandingPage} />;
			case pages.IFTPaymentDetails:
				return (
					<div>
						<IFTPaymentDetails onEditContinue={this.handleContinue} handleBackParent={handleBackParent} />
					</div>
				);
			case pages.IFTReview:
				return (
					<div>
						<PaymentTimedOutModal handleRoute={handleRoute} />
						<IFTReviewPage
							handleContinue={this.handleContinue}
							handlePaymentInReview={handlePaymentInReview}
							hasGroupApprovalsEnabled={hasGroupApprovalsEnabled}
						/>
					</div>
				);
			case pages.IFTSubmitted:
				return (
					<div>
						<IFTConfirmedPage handleRoute={handleRoute} handleReset={this.handleReset} />
					</div>
				);
			case 'Payee':
				return (
					<div>
						<AddPayeeLayoutContainer handleRoute={handleRoute} />
					</div>
				);
			default:
				return null;
		}
	}
}

LayoutContainer.propTypes = {
	page: PropTypes.string.isRequired,
	hasError: PropTypes.bool,
	handleRoute: PropTypes.func,
	submitIFTPaymentsForReview: PropTypes.func,
	submitIFTConfirmedPayments: PropTypes.func,
	addPayments: PropTypes.func,
	continueToPayments: PropTypes.func,
	handleSelectPaymentType: PropTypes.func,
	continueToPaymentDetails: PropTypes.func,
	handlePaymentInReview: PropTypes.func,
	handleBackParent: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	resetPaymentList: PropTypes.func,
	reset: PropTypes.func,
};

export default connect(mapState, mapDispatch)(withScrollTop(withCalendar(LayoutContainer)));
